export const API_ENDPOINT = 'content';


// WEBPACK FOOTER //
// ./src/state/modules/content/configurations/endpoints.js